import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../utils/translations';

const Translation = ({ textKey }) => {
  const { language } = useLanguage();
  
  // Get the translation for the current language, fallback to English if not found
  const translatedText = translations[language]?.[textKey] || translations.en[textKey] || textKey;
  
  return <>{translatedText}</>;
};

export default Translation;
